import axios from 'axios';

const state= {
    Items:{ 
        data:[],
        total : 0,
        pages: {
            totalPage : 1,
            page : 1,
            limit : 25,
            filter : {
    
            }
        }
    },
    Loadings:{
        list:false,
        create:false,
    },
    AllItem : [],
    organizations: [],
    organizationsUser: [],
    organization: null,
    companyType: {
        value: 'all_companies'
    }
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    AllItems : (state) => state.AllItem,
    Organizations : (state) => state.organizations,
    organizationsUser : (state) => state.organizationsUser,
    organization : (state) => state.organization,
    companyType : (state) => state.companyType,
};

const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/organizations`, {params:params})
                .then(response => {
                    response.data.data.pages = params
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async searchItemsInUser({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/organizations`, { params: params})
                .then(response => {
                    commit( 'setOrganizationsUser', { meth: 'list', data: response.data.data.items } );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async createItem({commit}, params){
        //params.isPlatformOwner = params.isPlatformOwner ? 1:0;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"create",val:true});
            global.axios.post(`api/organizations`, params)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    if(response.data.data.is_supplier) {
                        commit( 'AccountSupplierController/createSupplier', response.data.data, { root: true } );
                    }
                    commit( 'createCompany', response.data.data);
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        //params.isPlatformOwner = params.isPlatformOwner ? 1:0;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"create",val:true});
            global.axios.put(`api/organizations/${params.id}`, params)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    commit( 'setOrganizationsUser', { meth: 'update', data: response.data.data });
                    commit( 'AccountSupplierController/checkSuppler', response.data.data, { root: true } );
                    commit( 'updateListOraganization', response.data.data)
                    //commit( 'updateItemOrganizations', { index: params.index, data:response.data.data });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.delete(`api/organizations`, {
                data:{
                    ids:params
                }
            })
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setOrganizationsUser', { meth: 'delete', data: params });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getAllItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/organizations/all`, {params:params})
                .then(response => {
                    commit( 'setAllItems', response.data.data.items );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async searchOrganizations({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/organizations/search`, {
                method: "GET",
                params:  {
                    filter: params
                },
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject( error ))
        });
    },
    async getOrganizations({commit}, params){
       
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/organizations/${params}`)
            .then(response => {
                commit( 'setOrganizationItems', response.data.data );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    /* Contactable Emails */
    async getContactableEmailsItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/contactable-emails`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createContactableEmailItem({commit}, params){
        //params.isPlatformOwner = params.isPlatformOwner ? 1:0;
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/contactable-emails`, params)
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async updateContactableEmailItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/contactable-emails/${params.id}`, params)
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteContactableEmailsItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/contactable-emails`, {
                data:{
                    ids:params
                }
            }).then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    /*updateItemOrganizations(state, data) {
        if(data.index) {
            state.Items.data[data.index] = data.data
        }
    },*/
    setLoadings (state,data) {
        if(data.key === "list"){
            state.Loadings.list = data.val;
        }
        if(data.key === "create"){
            state.Loadings.create = data.val;
        }
    },
    setAllItems (state,data) {
        state.AllItem = data;
    },
    setOrganizations (state,data) {
        state.organizations = data;
    },
    setOrganizationsUser (state,data) {
        if(data.meth.includes('list')) {
            state.organizationsUser = data.data
        }
        if(data.meth.includes('create')) {
            state.organizationsUser.push(data.data)
        }
        if(data.meth.includes('update')) {
            state.organizationsUser = state.organizationsUser.map(item => item.id == data.data.id ? data.data : item)
        }
        if(data.meth.includes('delete')) {
            state.organizationsUser = state.organizationsUser.filter(item => item.id.toString().includes(data.data) == false)
        }
    },
    setOrganizationItems (state, data) {
        state.organization = data;
    },
    updateListOraganization(state, data) {
        if(state.Items.data.length > 0) {
           state.Items.data =  state.Items.data.map(item => item.id === data.id ? data : item)
        }
    },
    createCompany (state, data) {
        if(state.Items.data.length > 0) {
            state.Items.data.push(data);
            state.Items.total ++;
            return;
        } 
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}